<template>
    <div id="loading">
        <inline-svg
            :src="loading_icon"
            width="80"
            height="80"
        />
    </div>
</template>

<script>
    import loading_icon from '@/assets/icons/loading/eclipse.svg';
    export default {
        data() {
            return {
                loading_icon
            }
        }
    }
</script>